import { ChangeDetectionStrategy, Component, inject, input, Input, OnInit } from '@angular/core';
import { StateComponent } from '../../../../../../../../../components/state/state.component';
import { IBettingOption } from '../../model/betting.model';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';

@Component({
  selector: 'oo-button-group-betting',
  templateUrl: './button-group-betting.component.html',
  styleUrls: ['./button-group-betting.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonToggleGroup, FormsModule, ReactiveFormsModule, MatButtonToggle],
})
export class ButtonGroupBettingComponent<T> extends StateComponent<ButtonGroupBettingComponentState> implements OnInit {

  readonly bettingForm = input.required<UntypedFormGroup>();
  readonly key = input.required<string>();
  readonly initValue = input.required<string | string[] | undefined | T>();
  state: ButtonGroupBettingComponentState = {
    options: [],
    form: null!,
  };
  private readonly fb = inject(UntypedFormBuilder);

  @Input() set options(options: IBettingOption<any>[]) {
    this.updateState({ options });
  }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm(): void {
    this.updateState({
      form: this.fb.control(this.initValue(), [Validators.required]),
    });
    this.bettingForm().addControl(this.key(), this.state.form);
    this.detectChangesAfterTick();
  }
}

interface ButtonGroupBettingComponentState {
  options: IBettingOption[];
  form: UntypedFormControl;
}
